import { useSelector } from 'react-redux';
import _get from 'lodash/get';

export default function useLinkedInImportEnabled() {
  return useSelector(state => _get(state, 'client.settings.onboarding.linkedIn.enabled', true));
}
